import { StarIcon as HeroStarIcon } from '@heroicons/react/24/solid';
export const StarIcon = HeroStarIcon;
